var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26875 0 0 6.26875 0 14C0 21.7313 6.26875 28 14 28C21.7313 28 28 21.7313 28 14C28 6.26875 21.7313 0 14 0ZM17.25 9.90312C17.25 10.2219 17.0969 10.525 16.8375 10.7125L12.2937 14L16.8375 17.2875C17.0969 17.475 17.25 17.775 17.25 18.0969V19.5625C17.25 19.7656 17.0187 19.8844 16.8531 19.7656L9.16562 14.2031C9.13368 14.1801 9.10767 14.1498 9.08972 14.1148C9.07178 14.0797 9.06242 14.0409 9.06242 14.0016C9.06242 13.9622 9.07178 13.9234 9.08972 13.8883C9.10767 13.8533 9.13368 13.823 9.16562 13.8L16.8531 8.2375C16.8905 8.21038 16.9346 8.19413 16.9807 8.19055C17.0267 8.18698 17.0728 8.19623 17.1139 8.21726C17.155 8.23829 17.1895 8.2703 17.2135 8.30972C17.2375 8.34915 17.2502 8.39446 17.25 8.44063V9.90312Z",
    fill: "#006854"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCircle);
export default __webpack_public_path__ + "static/media/left-circle.9b9e3e9f926f48a216fd875e4b840df1.svg";
export { ForwardRef as ReactComponent };